import React, { useCallback } from 'react';
import { Box, Text, Button, TextButton } from '@wix/design-system';
import { SparklesFilledSmall } from '@wix/wix-ui-icons-common';
import { GENERATE_PROJECT_WIDGET } from '../consts';
import { useDisabledWidget } from '../../../../shared/disabled-widget/useDisabledWidget';
export const GenerateProjectWidget = _ref => {
  let {
    data: {
      widgetTitle,
      widgetSubtitle,
      secondaryButton,
      primaryButton
    },
    context: {
      send,
      onWidgetAction,
      emitSideEffect
    },
    config
  } = _ref;
  const {
    areControlsDisabled
  } = useDisabledWidget(config);
  const handleWidgetAction = useCallback(actionData => {
    onWidgetAction == null || onWidgetAction(GENERATE_PROJECT_WIDGET, {
      action: actionData.buttonName,
      value: actionData
    });
    emitSideEffect(actionData.sideEffectName, actionData);
    send(actionData.responseText);
  }, [onWidgetAction, emitSideEffect, send]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "12px",
    paddingTop: "SP1",
    paddingBottom: "SP1",
    minWidth: "400px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold",
    skin: areControlsDisabled ? 'disabled' : undefined
  }, widgetTitle), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    skin: areControlsDisabled ? 'disabled' : undefined
  }, widgetSubtitle), /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    gap: "18px"
  }, /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    weight: "thin",
    skin: "standard",
    disabled: areControlsDisabled,
    onClick: () => handleWidgetAction({
      buttonName: secondaryButton.buttonName,
      sideEffectName: secondaryButton.sideEffectName,
      responseText: secondaryButton.respondText
    })
  }, secondaryButton.label), /*#__PURE__*/React.createElement(Button, {
    disabled: areControlsDisabled,
    size: "tiny",
    skin: "ai",
    prefixIcon: /*#__PURE__*/React.createElement(SparklesFilledSmall, null),
    onClick: () => handleWidgetAction({
      buttonName: primaryButton.buttonName,
      sideEffectName: primaryButton.sideEffectName,
      responseText: primaryButton.respondText
    })
  }, primaryButton.label)));
};
//# sourceMappingURL=GenerateProjectWidget.js.map